import script from "./SettingsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsForm.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsForm.vue?vue&type=style&index=0&id=2ee9bfe2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee9bfe2"]])

export default __exports__